<nb-card>
  <div class="form-inline">
    <input
      nbInput
      shape="semi-round"
      [(ngModel)]="inDate"
      [nbDatepicker]="startDate"
      (ngModelChange)="dateChange()"
      class="in-date"
    />
    <nb-datepicker #startDate format="dd/MM/yyyy"></nb-datepicker>

    <input
      nbInput
      shape="semi-round"
      type="text"
      [(ngModel)]="inTime"
      [nbTimepicker]="startTime"
      (ngModelChange)="dateChange()"
      class="in-time"
    />
    <nb-timepicker #startTime></nb-timepicker>
  </div>
</nb-card>
